import React, { useContext, useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux'
import { withTranslation } from "react-i18next";
import { Space, Table, Tag } from 'antd';

import Chart from 'components/monitoring/Chart';
import * as types from 'reducer/actionTypes';
import { isEmpty, getTime } from 'script/common';

class RealTime extends React.Component {
	componentDidMount() {
	}
	
	render() {
		const chartData = {
			[this.props.dataApp.word]: [
				{
					id : this.props.dataKey.mongodb.name,
					data: this.props.getChartData(this.props.word, this.props.dataKey.mongodb.key)
				},
				{
					id : this.props.dataKey.webApplication.name,
					data: this.props.getChartData(this.props.word, this.props.dataKey.webApplication.key)
				},
				{
					id : this.props.dataKey.filterServer.name,
					data: this.props.getChartData(this.props.word, this.props.dataKey.filterServer.key)
				},
				{
					id : this.props.dataKey.docServer.name,
					data: this.props.getChartData(this.props.word, this.props.dataKey.docServer.key)
				},
				{
					id : this.props.dataKey.docServerAction.name,
					data: this.props.getChartData(this.props.word, this.props.dataKey.docServerAction.key)
				},
			],

			[this.props.dataApp.show]: [
				{
					id : this.props.dataKey.mongodb.name,
					data: this.props.getChartData(this.props.show, this.props.dataKey.mongodb.key)
				},
				{
					id : this.props.dataKey.webApplication.name,
					data: this.props.getChartData(this.props.show, this.props.dataKey.webApplication.key)
				},
				{
					id : this.props.dataKey.filterServer.name,
					data: this.props.getChartData(this.props.show, this.props.dataKey.filterServer.key)
				},
				{
					id : this.props.dataKey.docServer.name,
					data: this.props.getChartData(this.props.show, this.props.dataKey.docServer.key)
				},
				{
					id : this.props.dataKey.docServerAction.name,
					data: this.props.getChartData(this.props.show, this.props.dataKey.docServerAction.key)
				},
			],

			[this.props.dataApp.cell]: [
				{
					id : this.props.dataKey.mongodb.name,
					data: this.props.getChartData(this.props.cell, this.props.dataKey.mongodb.key)
				},
				{
					id : this.props.dataKey.webApplication.name,
					data: this.props.getChartData(this.props.cell, this.props.dataKey.webApplication.key)
				},
				{
					id : this.props.dataKey.filterServer.name,
					data: this.props.getChartData(this.props.cell, this.props.dataKey.filterServer.key)
				},
			],

			[this.props.dataApp.common]: [
				{
					id : this.props.dataKey.redis.name,
					data: this.props.getChartData(this.props.common, this.props.dataKey.redis.key)
				},
				{
					id : this.props.dataKey.mongodbGridFS.name,
					data: this.props.getChartData(this.props.common, this.props.dataKey.mongodbGridFS.key)
				}
			],
		}

		const tableData = [
			{
				key: this.props.dataApp.word,
				name: this.props.dataApp.word,
				proccessInfo: [
				{
					name : this.props.dataKey.mongodb.name,
					state : this.props.lastData.word?.[this.props.dataKey.mongodb.key]
				},
				{
					name : this.props.dataKey.webApplication.name,
					state : this.props.lastData.word?.[this.props.dataKey.webApplication.key]
				},
				{
					name : this.props.dataKey.filterServer.name,
					state : this.props.lastData.word?.[this.props.dataKey.filterServer.key]
				},
				{
					name : this.props.dataKey.docServer.name,
					state : this.props.lastData.word?.[this.props.dataKey.docServer.key]
				},
				{
					name : this.props.dataKey.docServerAction.name,
					state : this.props.lastData.word?.[this.props.dataKey.docServerAction.key]
				}
				],
			},
			{
				key: this.props.dataApp.show,
				name: this.props.dataApp.show,
				proccessInfo: [
					{
						name : this.props.dataKey.mongodb.name,
						state : this.props.lastData.show?.[this.props.dataKey.mongodb.key]
					},
					{
						name : this.props.dataKey.webApplication.name,
						state : this.props.lastData.show?.[this.props.dataKey.webApplication.key]
					},
					{
						name : this.props.dataKey.filterServer.name,
						state : this.props.lastData.show?.[this.props.dataKey.filterServer.key]
					},
					{
						name : this.props.dataKey.docServer.name,
						state : this.props.lastData.show?.[this.props.dataKey.docServer.key]
					},
					{
						name : this.props.dataKey.docServerAction.name,
						state : this.props.lastData.show?.[this.props.dataKey.docServerAction.key]
					}
				],
			},

			{
				key: this.props.dataApp.cell,
				name: this.props.dataApp.cell,
				proccessInfo: [
					{
						name : this.props.dataKey.mongodb.name,
						state : this.props.lastData.cell?.[this.props.dataKey.mongodb.key]
					},
					{
						name : this.props.dataKey.webApplication.name,
						state : this.props.lastData.cell?.[this.props.dataKey.webApplication.key]
					},
					{
						name : this.props.dataKey.filterServer.name,
						state : this.props.lastData.cell?.[this.props.dataKey.filterServer.key]
					}
				],
			},

			{
				key: this.props.dataApp.common,
				name: this.props.dataApp.common,
				proccessInfo: [
					{
						name : this.props.dataKey.redis.name,
						state : this.props.lastData.common?.[this.props.dataKey.redis.key]
					},
					{
						name : this.props.dataKey.mongodbGridFS.name,
						state : this.props.lastData.common?.[this.props.dataKey.mongodbGridFS.key]
					}
				],
			},
		];
		
		const columns = [
			{
			  title: 'Service',
			  key: 'name',
			  dataIndex: 'name',
			  render: (text) => <a>{text}</a>,
			},
			{
			  title: 'Proccess Info',
			  key: 'proccessInfo',
			  dataIndex: 'proccessInfo',
			  render: (_, { proccessInfo }) => (
				<>
				  {proccessInfo.map((data) => {
					let color = (data.state) ? 'green' : 'volcano';			
					return (
					  <Tag style={{ marginBottom: '8px', display: 'block' }} color={color} key={data.name}> {data.name} </Tag>
					);
				  })}
				</>
			  ),
			},
			{
			  title: 'Monitoring',
			  key: 'chart',
			  render: (_, data) => {
				return (
					<Chart
						height='100'
						data={chartData[data.name]}
						max={'auto'}
						min={'auto'}
					/>
				)
			  }
			},
		  ];

		return (
			<div>
				<Table 
					columns={columns} 
					dataSource={tableData} 
					pagination={false}
					size="middle"
				/>
			</div>
		)
	}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return{
		word: reducers.monitoring.word,
		show: reducers.monitoring.show,
		cell: reducers.monitoring.cell,
		common: reducers.monitoring.common,
		lastData: reducers.monitoring.lastData,
		dataApp: reducers.monitoring.dataApp,
		dataKey: reducers.monitoring.dataKey,
		apiCalling: reducers.apiCalling.apiCalling,
	}
}

// 컴포넌트의 함수형 poprs를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return{
		fetchMessageBoxRequest: (value) => {dispatch({type: types.FETCH_MESSAGEBOX_REQUEST, message:value})}
	}
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RealTime))